// Lib
import React from 'react';

// Components
import Feather from '../../../Feather';

// Styles
import { useStyles } from './ErrorStyles';

const Error = ({ error, fontSize = 16 }) => {
  const { classes } = useStyles({ fontSize });

  return (
    <div
      className={classes.errorContainer}
      data-testid="address-import-message">
      <Feather className={classes.errorIcon} nativeColor type="error" />
      <span className={classes.error}>{error}</span>
    </div>
  );
};

export default Error;
